import React from 'react';

import { SelectAmount } from '../select-amount';

export function NewContributionSelectAmount() {
  return <SelectAmount mode="new" />;
}
